<igo-layer-search
  [initialValue]="term()"
  [floatLabel]="floatLabel()"
  placeholder="igo.geo.layer.filterPlaceholder"
  tooltip="igo.geo.layer.subsetLayersListKeyword"
  (searchChange)="handleTermChange($event)"
/>

<div class="actions-container">
  <button
    mat-icon-button
    [color]="selectionActive ? 'warn' : 'primary'"
    [matTooltip]="
      selectionActive
        ? ('igo.geo.layer.deactivateSelectionMode' | translate)
        : ('igo.geo.layer.activateSelectionMode' | translate)
    "
    matTooltipShowDelay="500"
    (click)="toggleSelectionMode()"
  >
    <mat-icon>{{
      selectionActive ? 'remove_done' : 'library_add_check'
    }}</mat-icon>
  </button>

  @if (viewerOptions()?.group?.canCreate) {
    <button
      mat-icon-button
      [disabled]="!viewerOptions().group.enable"
      [matTooltip]="'igo.geo.layer.group.create' | translate"
      matTooltipShowDelay="500"
      type="button"
      color="primary"
      (click)="createGroup()"
    >
      <mat-icon>create_new_folder</mat-icon>
    </button>
  }
</div>
